import { DELIVERY_OPTIONS_DEFAULT_NOTES } from 'constants/delivery-options'

export const generateTicketTitle = (section: number | string, row: number | string) =>
  `Section ${section} • Row ${row}`

export const getTicketDeliveryNotes = (format: string) =>
  DELIVERY_OPTIONS_DEFAULT_NOTES[format] || format || ''
